import { render, staticRenderFns } from "./zwgk-door-textContent.vue?vue&type=template&id=9009dde6&"
import script from "./zwgk-door-textContent.vue?vue&type=script&lang=js&"
export * from "./zwgk-door-textContent.vue?vue&type=script&lang=js&"
import style0 from "./zwgk-door-textContent.vue?vue&type=style&index=0&id=9009dde6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports